import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=30d1f3a4&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
import style0 from "./Settings.vue?vue&type=style&index=0&id=30d1f3a4&prod&scoped=true&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=30d1f3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d1f3a4",
  null
  
)

export default component.exports